<template>
  <div class="admin-shell" :class="{ 'is-collapsed': isCollapse }">
    <aside class="admin-sidebar"><AsideA :isCollapse="isCollapse" /></aside>
    <div class="admin-workspace">
      <header class="admin-topbar">
        <MainHeader :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" :username="username" @doCollapse="toggleSidebar" />
      </header>
      <main class="admin-content"><slot /></main>
      <footer class="admin-footer">DAINTY LOGISTICS <span>仓储 · 订单 · 客户管理</span></footer>
    </div>
  </div>
</template>

<script>
import AsideA from './AsideA.vue';
import MainHeader from './MainHeader.vue';

export default {
  name: 'AdminLayout',
  components: { AsideA, MainHeader },
  data() {
    return {
      isCollapse: window.innerWidth < 1024 || localStorage.getItem('admin_sidebar_collapsed') === 'true',
      username: localStorage.getItem('user_name') || '未登录',
    };
  },
  methods: {
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
      localStorage.setItem('admin_sidebar_collapsed', String(this.isCollapse));
    },
  },
};
</script>
